<template>
  <div class="row">
    <div v-bind:class="propColunas">
      <Dialog id="dialogEditEventos" titulo="Eventos selecionados" ref="dialog" :modal="propView == 'modal'">
        <form class="text-left">

          <div class="row" v-if="retornaSite() !== 'Share'">
            <div class="col-sm-6">
              <div class="form-group row">
                <label class="col-sm-12 col-form-label">Status</label>
                <div class="col-sm-12">
                  <Combo
                    :itens="[
                      { id: '', nome: '# Atual' },
                      { id: '1', nome: 'Previsto' },
                      { id: '2', nome: 'Invisivel' },
                      { id: '3', nome: 'Ao Vivo' },
                      { id: '4', nome: 'Encerrado' }
                    ]"
                    v-model="item.situacao"
                    :itemSelecione="false"
                  />
                </div>
              </div>
            </div>

            <div class="col-sm-6">

                <div class="form-group row">
                <label class="col-sm-12 col-form-label">Servidor</label>
                <div class="col-sm-12">
                  <Combo
                    :itens="servidoresHabilitados"
                    v-model="servidorSelecionado"
                    :itemSelecione="false"
                  />
                  
                </div>
              </div>

            </div>
          </div>

        </form>

        <template v-slot:rodape>
          <button type="button" class="btn btn-outline-primary btn-sm" @click="salvarItens()">Alterar</button>
          <button type="button" class="btn btn-outline-danger btn-sm" v-if="view == 'modal'" data-dismiss="modal"  @click="excluirItens()">Excluir</button>
          <button type="button" class="btn btn-outline-dark btn-sm" v-if="view == 'modal'" @click="$emit('limparSelecao')" data-dismiss="modal">Limpar seleção</button>
        </template>

      </Dialog>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";

import Dialog from "../components/Dialog.vue";
import Combo from "../components/Combo.vue";
var _ = require("lodash");

export default {
  name: "EditEventos",
  components: { Dialog, Combo },
  props: {
    selecionados: { type: Array },
    propView: { type: String, default: "modal" },
    propColunas: {
      type: Array,
      default: function () {
        return ["col-md-12"];
      },
    },
  },
  methods: {
    
    retornaSite()
    {
      return this.$site;
    },
    async salvarItens() {
      
      var apiRequest;
      var body = _.cloneDeep(this.item);

      var arrServidorDados = this.servidorSelecionado.split("_");

      if(arrServidorDados.length > 1)
      {

        body.servidorTipo = arrServidorDados[0];
        body.servidor = arrServidorDados[1];

      }

      if (
        body.situacao == "1" ||
        body.situacao == "2" ||
        body.situacao == "3" ||
        body.situacao == "4"
      ) {
        body.situacao = parseInt(body.situacao);
      }

      body.ids = _.cloneDeep(this.selecionados);
      
      apiRequest = await api.put("/evento/eventos", body);

      if (!apiRequest.data.erro) {
        this.$refs.dialog.fechar();
        this.$emit("salvarItens");
      }

    },
    async excluirItens() {
      
      var apiRequest;
      var body = {};

      if(confirm("Deseja excluir os eventos selecionados ?"))
      {

        body.ids = _.cloneDeep(this.selecionados);

        apiRequest = await api.put("/evento/delete/eventos", body);
        
        if (!apiRequest.data.erro) {
          this.$refs.dialog.fechar();
          this.$emit("excluirItens");
        }

      }

    },
    limpar()
    {
      this.item.situacao = "";
      this.item.servidor = "";
      this.item.servidorTipo = "";
      this.item.servidorSelecionado = "";
    }
    
  },
  mounted() {
    this.view = this.propView;
  },
  computed :{

    servidoresHabilitados: function () {

      var servidores = [];

      servidores.push({ id: '', nome: '# Atual' });

      this.$global.servidores_sip_array().filter(function(item){

        if(item.router == false)
        {
          servidores.push(item);
        }

        return true;
      });

      return servidores;
      
    }

  },
  data: function () {
    return {
      item: {
        ids:[],
        situacao: "",
        servidor: "",
        servidorTipo: ""
      },
      servidorSelecionado:"",
      view: ""
    };
  },
};
</script>

<style></style>
